import { AppServerAPI, WidgetStyle } from '@sdbn/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportPeriod } from './model/reportperiod';
import { Subscription } from 'rxjs';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-report-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  reportingPeriods = [
    new ReportPeriod('DAY', 'Tagesreport', 'tmc-yard.ui.reporting.dashboard.period-day'),
    new ReportPeriod('MONTH', 'Monatsreport', 'tmc-yard.ui.reporting.dashboard.period-month'),
    new ReportPeriod('YEAR', 'Jahresreport', 'tmc-yard.ui.reporting.dashboard.period-year')
  ];

  selected = this.reportingPeriods[0]; // Default is day
  data: any;
  initialized = false;

  private languageSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI) {

    super();

    this.languageSubscription = translationService.changed.subscribe(language => {

    });
  }

  chooseReportPeriod(item) {
    this.selected = item;
    this.loadReport(item);
  }

  isSelected(item: ReportPeriod): boolean {
    return this.selected === item;
  }

  private loadReport(period: ReportPeriod) {
    this.appServerAPI.execute(`/client/control/reporting/dashboard`, { key: this.selected.key })
      .subscribe(
        response => { this.data = response; this.initialized = true; }
      );
  }


  ngOnInit() {
    this.loadReport(this.selected);
  }

  ngOnDestroy(): void {

    super.ngOnDestroy();

    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    for (const period of this.reportingPeriods) {
      if (period.key === this.widgetReference?.data?.period) {
        this.selected = period;
      }
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
